module.exports = __webpack_public_path__ + "img/personality-disorder.80f49a80.png";